import { Routes } from '@angular/router';
import { crmAuthGuard } from 'common-module/auth';
import { crmLayoutOutletRoute } from 'common-module/layout-v2';

import { requiredRole } from './config/auth.config';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('common-module/auth').then((m) => m.authRoutes),
  },
  crmLayoutOutletRoute({
    canActivate: [crmAuthGuard()],
    data: { allowedRoles: [requiredRole] },
    children: [
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes'),
      },
      {
        path: '**',
        redirectTo: 'users',
      },
    ],
  }),
];
